import { styled } from "@mui/material/styles";
import { TextField } from "@mui/material";

export const SearchBox = styled(TextField)`
  background: white;
  color: #242333;
  border-radius: 16px;

  & .MuiOutlinedInput-root {
    border-radius: 16px;
    & input::placeHolder {
        color: #242333; 
        opacity: 100%;
        font-weight: 600;
    }
  }
`;

export default SearchBox;